import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconsModule } from '../../../shared/modules/icons.module';
import { ApplyButtonComponent } from '../../../shared/components/apply-button/apply-button.component';

interface Problem {
  icon: string;
  title: string;
  description: string;
}

@Component({
  standalone: true,
  selector: 'app-problems-section',
  imports: [CommonModule, IconsModule, ApplyButtonComponent],
  templateUrl: './problems-section.component.html',
  styleUrls: ['./problems-section.component.scss']
})
export class ProblemsSectionComponent {
  problems: Problem[] = [
    {
      icon: 'dollar-sign',
      title: 'Finanzielle Engpässe?',
      description: 'Du weißt, dass du mehr kannst, aber hast noch keinen Weg gefunden, deine Fähigkeiten auch in Geld zu verwandeln?'
    },
    {
      icon: 'clock',
      title: '9 to 5 raubt dir Freiheit?',
      description: 'Kein Bock mehr, jeden Tag denselben langweiligen 9 to 5 Job zu machen und für jemand anderen zu arbeiten?'
    },
    {
      icon: 'users',
      title: 'Fehlende Unterstützung?',
      description: 'Bist du es leid, alleine zu kämpfen und wünschst dir ein unterstützendes Netzwerk von Gleichgesinnten, die dir helfen können?'
    }
  ];
} 